import React from "react";
import { Link } from "react-router-dom";
import "./SueSavageRumbaugh.css";

const publicationHighlights = [
  {
    year: "1978",
    title: "Chimpanzee language research: Status and potential",
    href: "/pdf/1978-Chimpanzee-Language-Research.pdf",
  },
  {
    year: "1986",
    title:
      "Spontaneous symbol acquisition and communicative use by pygmy chimpanzees",
    href: "/pdf/1986-Spontaneous-Symbol-Acquisition.pdf",
  },
  {
    year: "1993",
    title: "Language comprehension in ape and child",
    href: "/pdf/1993-Language-Comprehension-Ape.pdf",
  },
  {
    year: "2005",
    title: "Culture prefigures cognition in Pan/Homo bonobos",
    href: "/pdf/2005-Culture-Prefigures-Cognition.pdf",
  },
];

const SueSavageRumbaugh = () => (
  <main className="sue-page">
    <section className="sue-hero" aria-labelledby="sue-title">
      <div className="sue-hero__text">
        <p className="sue-eyebrow">Ape language research</p>
        <h1 id="sue-title">Sue Savage-Rumbaugh</h1>
        <p>
          Dr. Sue Savage-Rumbaugh is an experimental psychologist and
          primatologist whose work with chimpanzees, bonobos, lexigrams, and
          spoken language comprehension helped define the modern ape language
          research trajectory.
        </p>
        <div className="sue-actions">
          <Link to="/research">Explore the research trajectory</Link>
          <Link to="/SueBiblio">View bibliography</Link>
        </div>
      </div>
      <figure className="sue-hero__media">
        <img
          src="/sue-savage-rumbaugh.jpg"
          alt="Dr. Sue Savage-Rumbaugh"
        />
        <figcaption>
          Research associated with Dr. Savage-Rumbaugh connects Lana, Sherman
          and Austin, Kanzi, bonobos, lexigrams, and the conditions that make
          symbolic communication possible.
        </figcaption>
      </figure>
    </section>

    <section className="sue-body" aria-label="Sue Savage-Rumbaugh research overview">
      <article>
        <h2>Why Her Work Matters</h2>
        <p>
          Savage-Rumbaugh's research moved ape language studies beyond isolated
          command-response demonstrations. Across the archive, the central
          question becomes developmental and cultural: what can chimpanzees and
          bonobos understand and express when they live inside a durable,
          language-rich symbolic environment?
        </p>
        <p>
          That question links the early LANA Project and Yerkish work to later
          studies of Sherman and Austin, then to Kanzi and the bonobos whose
          lexigram use, spoken English comprehension, observational learning,
          tool work, and social relationships reshaped debates about language
          and mind.
        </p>
      </article>

      <article>
        <h2>Kanzi and Bonobo Research</h2>
        <p>
          Kanzi became the best-known figure in this trajectory because his
          communication emerged through social exposure, shared routines, and
          participation in a human-bonobo cultural world. Savage-Rumbaugh's work
          presented Kanzi not as a trained performer but as a developing
          communicative being whose comprehension demanded a broader scientific
          vocabulary.
        </p>
        <p>
          Bonobo Hope Initiative's current work is focused on restoring the
          research conditions that made that trajectory possible: access,
          continuity, lexigram resources, careful documentation, and serious
          public understanding of bonobos and chimpanzees as communicative
          beings.
        </p>
      </article>

      <aside className="sue-publications" aria-label="Selected publications">
        <h2>Selected Publications</h2>
        <ul>
          {publicationHighlights.map((item) => (
            <li key={item.href}>
              <span>{item.year}</span>
              <a href={item.href} target="_blank" rel="noreferrer">
                {item.title}
              </a>
            </li>
          ))}
        </ul>
      </aside>
    </section>

    <section className="sue-links" aria-label="Related research pages">
      <Link to="/research/kanzi">Kanzi research</Link>
      <Link to="/research/lexigrams">Lexigrams</Link>
      <Link to="/research/lana">Lana and the LANA Project</Link>
      <Link to="/research/sherman-and-austin">Sherman and Austin</Link>
      <Link to="/video">Video archive</Link>
    </section>
  </main>
);

export default SueSavageRumbaugh;
